export default "__VITE_ASSET__D5gnSN5S__"